import { render, staticRenderFns } from "./EditarAlerta.vue?vue&type=template&id=0fb882cc&"
import script from "./EditarAlerta.vue?vue&type=script&lang=ts&"
export * from "./EditarAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0fb882cc', component.options)
    } else {
      api.reload('0fb882cc', component.options)
    }
    module.hot.accept("./EditarAlerta.vue?vue&type=template&id=0fb882cc&", function () {
      api.rerender('0fb882cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/FugaCombustible/EditarAlerta.vue"
export default component.exports